import React from 'react';

import { FormResponse } from '@app/components/Pages/Area/AreaObjects';
import HelmetProvider from '@app/components/UI/HelmetProvider/HelmetProvider';
import Masthead from '@app/components/UI/MastHead/Masthead';
import RichText from '@app/components/UI/RichText/RichText';
import StudentExternshipModal from '@app/components/UI/StudentExternshipModal/StudentExternshipModal';

const StudentExternship: React.FC = () => {
	const mastHeadText = "Are you a veterinary student? Learn more about our one-of-a-kind externship program that gives you the unique opportunity to go inside a client's home to help manage every aspect of a pet's end-of-life care.";
	// eslint-disable-next-line max-len
	const externshipText = 'Saying goodbye to our beloved animals is extremely difficult, but Lap of Love veterinarians help ease this pain by guiding animals through a peaceful passing in the comfort of their home, surrounded by their loving family members. This unique practice of veterinary medicine and the many benefits it offers is unparalleled. As a part of our 3-day externship program, you will be given the opportunity to witness this first hand. Veterinary students from around the world are invited to shadow our veterinarians on house call hospice and euthanasia appointments, as well as learn from our veterinary care coordinators, who are the first line of communication with clients enduring the end-of-life decision.';
	const mastHeadTitle = (
		<>
			Lap of Love Student Externship Opportunities
		</>
	);

	const [modalVisible, setModalVisible] = React.useState(false);
	const [formSuccess, setFormSuccess] = React.useState<FormResponse>({ success: false, error: '' });
	return (
		<HelmetProvider>
			<div className="care-coordinator">
				<Masthead
					title={mastHeadTitle}
					imageSrc={require('@app/content/Student_Externship_Masthead.png')}
					text={mastHeadText}
					buttonText={(
						<button
							className="btn btn-primary"
							onClick={() => {
								setFormSuccess({ success: false, error: '' });
								setModalVisible(true);
							}}
						>
							Apply now
						</button>
					)}
					imageAlt="Veterinary externship"
				/>
				<RichText title="About the externship" text={externshipText} />
				<StudentExternshipModal
					modalVisible={modalVisible}
					setModalVisible={setModalVisible}
					formSuccess={formSuccess}
					setFormSuccess={setFormSuccess}
				/>
			</div>
		</HelmetProvider>
	);
};

export default StudentExternship;
